export const FEATURES_CONSTANTS = {
  title: "Key Benefits of Network Digital Twins",
  list: [
    {
      label: "Real-Time Emulation",
      text: "Conduct live testing of network changes and updates in a virtual environment to predict outcomes accurately.",
    },
    {
      label: "Performance Optimization",
      text: "Analyze network behavior under various scenarios to identify bottlenecks and enhance efficiency.",
    },
    {
      label: "Risk Mitigation",
      text: "Test and validate new technologies or configurations without affecting the operational network, reducing the likelihood of disruptions.",
    },
    {
      label: "Scalability",
      text: "Easily adjust the virtual network model to reflect changes in the physical network, accommodating growth and new deployments.",
    },
    {
      label: "Cost Efficiency",
      text: "Reduce the need for physical testing setups, saving on hardware and operational expenses.",
    },
    {
      label: "Enhanced Security Testing",
      text: "Evaluate security protocols and responses to potential threats in a safe, virtual space.",
    },
  ],
};
